import router from './router'
import store from './store'
import {
	getToken
} from '@/utils/auth'
import {
	Message
} from 'element-ui'

const whiteList = ['/login', '/forgetPwd', '/register', '/weiyuncang', '/huogeili', '/service', '/classiccase',
	'/channel', '/about', '/home', '/goodsDetails', '/search', '/helpCenter', '/kingBar','/storeProducts', '/activity/dailyRobbing'
]
const whiteData = ['/login', '/forgetPwd', '/register', '/weiyuncang', '/huogeili', '/service', '/classiccase',
	'/channel', '/about','/storeProducts','/activity/dailyRobbing'
]

router.beforeEach(async (to, from, next) => {
	// start progress bar
	if (to.meta.title) {
		document.title = to.meta.title
	}

	const hasToken = getToken()

	if (hasToken) {
		if (store.getters.mobile) {
			next()
		} else {
			try {
				await store.dispatch('user/getInfo')
				await store.dispatch('category/getCategoryList')
				next({
					...to,
					replace: true
				})
			} catch (error) {
				await store.dispatch('user/resetToken')
				Message.error(error || 'Has Error')
				next(`/login?redirect=${to.path}`)
			}
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) {
			next()
			if (whiteData.indexOf(to.path) === -1) {
				await store.dispatch('category/getCategoryList')
			}
			// in the free login whitelist, go directly
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			next(`/login?redirect=${to.path}`)
		}
	}
})

router.afterEach(() => {
	// finish progress bar
})
